resourcePaths = '{"rootPath":"/member","assetsPath":"/member/assets"}';/*
    FormSteps

    Constructs for  Provides methods to track and manage states for progress in forms.
    Constructs navigation elements and progress indicator for the tray view in
    the member portal. Provides methods to track and set navigation states and
    progress.

    Programmatic initialization of this component is highly recommended.

    HTML Structure:
        .form-steps
          section
            h2.form-steps__heading Update Email
            p.form-steps__summary This section is for updating email
            form.form-steps__form
          section
            h2.form-steps__heading Verify Email
            p.form-steps__summary  This section is for verifying
            form.form-steps__form

    JS initialization:
        $(".form-steps").mogo().create("FormSteps", { ... arguments ...});

    Arguments:
      steps (required) (required) [object]:
          A composite object that describes the steps in this series of forms

      allowMultipleActive (optional) [boolean]:
          Defaults to false. Whether only one step is allowed to be active at a time.

      onStepActiveChange (optional) [function (index, isActive)]:
          Callback when a step becomes active or inactive

      onStepVisibilityChange (optional) [function (index, isVisible)]:
          Callback when a step becomes visible or hidden

      onAllStepsComplete (optional) [function ()]:
          Callback when all steps are complete.



    Methods (see methods for additional usage):

      getAllActiveSteps()

      getAllVisibleSteps()

      getAllCompleteSteps()

      getAllEditableSteps()

      getAllEnabledSteps()

      isStepActive(index)

      isStepVisible(index)

      isStepComplete(index)

      isStepEditable(index)

      isStepEnabled(index)

      setStepActive(index, isActive)

      setStepVisibility(index, isVisible)

      setStepComplete(index)

      setStepEditable(index, isEditable)

      setStepEnabled(index, isEnabled)

      getNextStep()

      getPreviousStep()

      getStep(index)

      destroy()
*/
function FormSteps() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [];

  //Properties
  this.allowMultipleActive = false;
  //Callbacks
  this.onStepActiveChange =function(index, isActive) {};
  this.onStepVisibilityChange = function(index, isVisible) {};
  this.onAllStepsComplete = function() {};

  //Private
  this._steps = [];
  this._visible = [];
  this._active = [];

  this._classes = {
    activeComplete : "section--active-complete", //animation complete and the form is fully shown
    active : "section--active",
    visible : "section--visible",
    lastVisible : "section--visible--last-child",
    editable : "section--editable",
    disabled : "section--disabled",
    complete : "section--completed"
  };

  this.init = function() {
    this._$node = $(this.node);
    this._steps = this._$node.find("section").map(function(index, node) {
      var settings = this.steps[index];
      if (!settings) throw new Error(index + " Form Steps was not specified");

      var $node = $(node);
      if (settings.isVisible) {
        $node.addClass(this._classes.visible);
        this._visible.push(index);
      }
      if (settings.isActive) {
        if (!this.allowMultipleActive && this._active.length) throw new Error("Only one Form Steps can be active");
        this._setStepActive($node);
        this._active.push(index);
      }
      $node.toggleClass(this._classes.editable, settings.isEditable);
      $node.toggleClass(this._classes.complete, settings.isComplete);
      $node.toggleClass(this._classes.disabled, !settings.isEnabled);

      $node.find("h2").on("click.edit", this._onStepEditClick.bind(this, index));

      return $.extend({ index : index, node : node, $node : $node }, settings);
    }.bind(this));
    if (this._steps.length !== this.steps.length) throw new Error("All Form Steps were not specified");
    this._steps[this._visible[this._visible.length - 1]].$node.addClass(this._classes.lastVisible);
  };

  this.initAllReady = function() {
    this._$node.show();
  };

  this.destroy = function() {};

  /*
      Finds all active steps.

      Returns:
          Array of Objects of active form steps, an empty array otherwise.

  */
  this.getAllActiveSteps = function() {
    return this._active.map(function(index) { return this._steps[index]; }.bind(this));
  };

  /*
      Checks whether the specified step is active

      Arguments:
          index [integer] (required):
              The index of the step to check if it is active

      Returns:
          true if active, false otherwise.

  */
  this.isStepActive = function(index) {
    if (this._validStep(index)) return false;
    return this._steps[index].isActive;
  };

  /*
      Sets the specified step as active.
      If allowMultipleActive is false other steps will become inactive.
      If the step is hidden returns false because the step can't become active.

      Arguments:
          index [integer] (required):
              The index of the step to update

          isActive [boolean] (required):
              The new state of the step


      Returns:
          true if successful, false otherwise.

  */
  this.setStepActive = function(index, isActive) {
    if (this._validStep(index)) return false;
    var step = this._steps[index];
    if (!step.isVisible || !step.isEnabled) return false; //must also be

    var wasActive = (step.isActive);
    var activeChange = (wasActive !== isActive);
    step.isActive = isActive;

    if (activeChange) {
      if (isActive) {
        if (!this.allowMultipleActive && this._active.length) this.setStepActive(this._active[0], false);
        this._setStepActive(step.$node);
        this._active.push(index);
        this._active.sort(function(first,second){ return (first-second); }); //maintain this list as sorted
      } else if (wasActive) {
        step.$node.removeClass(this._classes.activeComplete);
        setTimeout(function() { step.$node.removeClass(this._classes.active); }.bind(this));
        this._active = this._active.filter(function(value) { return value != index; });
      }
      this.onStepActiveChange(index, isActive);
    }
    return true;
  };

  this._setStepActive = function($node) {
    $node
      .addClass(this._classes.active)
      .one(
        'webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend',
        function(){ $node.addClass(this._classes.activeComplete); }.bind(this)
      );
  };

  /*
      Check whether the specified step is visible

      Arguments:
          index [integer] (required):
              The index of the step to check if it is visible

      Returns:
          true if visible, false otherwise.

  */
  this.isStepVisible = function(index) {
    if (this._validStep(index)) return false;
    return this._steps[index].isVisible;
  };

  /*
      Finds all visible steps.

      Returns:
          Array of Objects of active form steps, an empty array otherwise.

  */
  this.getAllVisibleSteps = function() {
    return this._visible.map(function(index) { return this._steps[index]; }.bind(this));
  };

  /*
      Sets the specified step as visible.
      If the step doesn't exist return false

      Arguments:
          index [integer] (required):
              The index of the step to update

          isVisible [boolean] (required):
              The new visibility of the step


      Returns:
          true if successful, false otherwise.

  */
  this.setStepVisibility = function(index, isVisible) {
    if (this._validStep(index)) return false;
    var step = this._steps[index];

    var wasVisible = (step.isVisible);
    var visibilityChange = (wasVisible !==isVisible);

    if (visibilityChange) {
      this._steps[this._visible[this._visible.length - 1]].$node.removeClass(this._classes.lastVisible);
      step.isVisible = isVisible;
      if (isVisible) {
        step.$node.addClass(this._classes.visible);
        this._visible.push(index);
        this._visible.sort(function(first,second){ return (first-second); }); //maintain this list as sorted
      } else if (wasVisible) {
        step.$node.removeClass(this._classes.visible);
        this._visible = this._visible.filter(function(value) { return value != index; });
      }
      this.onStepVisibilityChange(index, isVisible);
      this._steps[this._visible[this._visible.length - 1]].$node.addClass(this._classes.lastVisible);
    }
    return true;
  };

  /*
      Finds the previous visible step to the current active steps and returns the index of that step.

      Returns:
          index of the previous step, -1 otherwise.

  */
  this.getPreviousStep = function() {
    if (!this._active.length) return -1;

    var firstActiveStep = this._active[0] - 1;
    while (firstActiveStep > -1) {
      if (this._steps[firstActiveStep].isVisible && this._steps[firstActiveStep].isEnabled) return firstActiveStep;
      firstActiveStep--;
    }
    return firstActiveStep;
  };

  /*
      Finds the next visible step to the current active step and returns the index of that step.
      Ignores hidden steps.

      Returns:
          index of the next step, -1 otherwise.

  */
  this.getNextStep = function() {
    if (!this._active.length) return this._visible[0];

    var lastActiveStep = this._active[this._active.length - 1] + 1;
    while (lastActiveStep < this._steps.length) {
      if (this._steps[lastActiveStep].isVisible && this._steps[lastActiveStep].isEnabled) return lastActiveStep;
      lastActiveStep++;
    }
    return -1;
  };

  /*
      Sets the specified step as complete.
      If the step doesn't exist return false

      Arguments:
          index [integer] (required):
              The index of the step to update

      Returns:
          true if successful, false otherwise.

  */
  this.setStepComplete = function(index) {
    if (this._validStep(index)) return false;
    var step = this._steps[index];
    if (!step.isComplete) {
      step.isComplete = true;
      step.$node.toggleClass(this._classes.complete, step.isComplete);

      if (this._getAllMatchingSteps("isComplete").length == this._visible.length) this.onAllStepsComplete();
    }
    return true;
  };

  /*
      Checks whether the specified step is complete

      Arguments:
          index [integer] (required):
              The index of the step to check if it is complete

      Returns:
          true if complete, false otherwise.

  */
  this.isStepComplete = function(index) {
    if (this._validStep(index)) return false;
    return this._steps[index].isComplete;
  };

  /*
      Finds all complete steps.

      Returns:
          Array of Objects of complete form steps, an empty array otherwise.

  */
  this.getAllCompleteSteps = function() {
    return this._getAllMatchingSteps("isComplete");
  };

  /*
      Sets the specified step as editable.
      If the step doesn't exist return false

      Arguments:
          index [integer] (required):
              The index of the step to update

          isEditable [boolean] (required):
              Whether the step is editable


      Returns:
          true if successful, false otherwise.

  */
  this.setStepEditable = function(index, isEditable) {
    if (this._validStep(index)) return false;
    var step = this._steps[index];

    var prevState = step.isEditable;
    var stateChange = isEditable !== step.isEditable;

    if (stateChange) {
      step.isEditable = isEditable;
      step.$node.toggleClass(this._classes.editable, step.isEditable);
    }
    return true;
  };

  /*
      Checks whether the specified step is editable

      Arguments:
          index [integer] (required):
              The index of the step to check if it is editable

      Returns:
          true if editable, false otherwise.

  */
  this.isStepEditable = function(index) {
    if (this._validStep(index)) return false;
    return this._steps[index].isEditable;
  };

  /*
      Finds all editable steps.

      Returns:
          Array of Objects of editable form steps, an empty array otherwise.

  */
  this.getAllEditableSteps = function() {
    return this._getAllMatchingSteps("isEditable");
  };

  /*
      Sets the specified step as enabled.
      If the step doesn't exist return false

      Arguments:
          index [integer] (required):
              The index of the step to update

          isEnabled [boolean] (required):
              Whether the step is editable


      Returns:
          true if successful, false otherwise.

  */
  this.setStepEnabled = function(index, isEnabled) {
    if (this._validStep(index)) return false;
    var step = this._steps[index];

    var prevState = step.isEnabled;
    var stateChange = isEnabled !== step.isEnabled;

    if (stateChange) {
      step.isEnabled = isEnabled;
      step.$node.toggleClass(this._classes.disabled, !step.isEnabled);
    }
    return true;
  };

  /*
      Checks whether the specified step is enabled

      Arguments:
          index [integer] (required):
              The index of the step to check if it is enabled

      Returns:
          true if enabled, false otherwise.

  */
  this.isStepEnabled = function(index) {
    if (this._validStep(index)) return false;
    return this._steps[index].isEnabled;
  };

  /*
      Finds all enabled steps.

      Returns:
          Array of Objects of enabled form steps, an empty array otherwise.

  */
  this.getAllEnabledSteps = function() {
    return this._getAllMatchingSteps("isEnabled");
  };

  /*
      Fetch the specified form step

      Arguments:
          index [integer] (required):
              The index of the step to fetch

      Returns:
          Object if successful, undefined otherwise.

  */
  this.getStep = function(index) {
    if (this._validStep(index)) return;

    return this._steps[index];
  };

  this._getAllMatchingSteps = function(state) {
    return this._steps.
      filter(function(step) { return step[state]; });
  };

  this._validStep = function(index) {
    return (index <= -1 && index >= this._steps.length);
  };

  this._onStepEditClick = function(index) {
    this.setStepActive(index, true);
  };
}
